<script lang="ts">
    import { faTrash } from '@fortawesome/free-solid-svg-icons'
    import Fa from 'svelte-fa'
    import type { Person } from '../../modules/eventsApi/persons/person'
    import type { ReferralItem } from '../../modules/toolsApi/referrals/referral-item'
    import type { User } from '../../modules/usersApi/users/user'
    import ZentitySelect from '../_common/z/zentity-select.svelte'

    export let item: ReferralItem

    function removeItem() {
        item = null
    }

    const relationships = [
        'amigo/amiga',
        'avô/avó',
        'colega de trabalho',
        'esposo/esposa',
        'irmão/irmã',
        'namorado/namorada',
        'pai/mãe',
        'filho/filha',
        'primo/prima',
        'tio/tia',
        'cunhado/cunhada',
        'sogro/sogra',
        'neto/neta',
        'sócio/sócia',
        'outro',
    ]
</script>

{#if item}
    <div class="mt-0">
        <div class="row mt-3">
            {#if item.personId}
                <div class="col-md-4">
                    <ZentitySelect fonte="pessoa" disabled={true} label="Nome" value={item.person} />
                </div>
            {:else}
                <div class="col-md-4">
                    <div class="input-group">
                        <label for="" class="input-group-text">Nome</label>
                        <input type="text" bind:value={item.person.name} class="form-control" />
                    </div>
                </div>
                <div class="col-md-3">
                    <div class="input-group">
                        <label for="" class="input-group-text">Celular</label>
                        <input type="text" bind:value={item.person.phone} class="form-control" />
                    </div>
                </div>
            {/if}
            <div class="col-md-3">
                <div class="input-group">
                    <label for="" class="input-group-text">Parentesco</label>
                    <select class="form-select" bind:value={item.relationship}>
                        <option value="" />
                        {#each relationships as relationship}
                            <option value={relationship}>{relationship}</option>
                        {/each}
                    </select>
                </div>
            </div>
            <div class="col-md-1">
                {#if !item.referralItemId}
                    <button on:click={removeItem} class="btn btn-secondary">
                        <Fa icon={faTrash} />
                    </button>
                {/if}
            </div>
        </div>
    </div>
{/if}
